/**
 * Service for fetching application maintenance status.
 */

import { CONFIG } from '../constants/constants';

/**
 * @typedef {object} MaintenanceStatus
 * @property {'NONE'|'WARNING'|'DOWN'} state - The maintenance state
 * @property {string} message - Maintenance message to display
 * @property {string} [startTime] - ISO timestamp of when maintenance starts
 * @property {string} endTime - ISO timestamp of when maintenance ends
 */

/**
 * Fetches the current maintenance status from the configured URL.
 *
 * @returns {Promise<MaintenanceStatus>} The current maintenance status
 */
export const fetchMaintenanceStatus = async () => {
    try {
        const response = await fetch(CONFIG.MAINTENANCE_URL);
        
        if (!response.ok) {
            throw new Error(`Maintenance status fetch failed: ${response.statusText}`);
        }

        const data = await response.json();
        
        // Validate and normalize the response
        if (!data || !['NONE', 'WARNING', 'DOWN'].includes(data.state)) {
            console.warn('Invalid maintenance status received:', data);
            return { state: 'NONE', message: '', startTime: '', endTime: '' };
        }

        return data;
    } catch (error) {
        console.error('Error fetching maintenance status:', error);
        // Fail open - assume no maintenance if check fails
        return { state: 'NONE', message: '', startTime: '', endTime: '' };
    }
};
